import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Loader from 'react-loader';
import { ExpandableTable } from '@quid/react-expandable-table';

import '@quid/theme/fonts/icons/index.css';
import withServices  from '../../../../HOCs/withServices';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import RadarGraph from '../../../../common/DataViz/radarGraph.Component';
import PerceptionsTile from '../../../../common/perceptionsTile.Component';

import './comparisonFilters.css';


interface IProps {
  services?: any;
}

class ComparisonFilters extends React.Component<IProps> {
  public state = {
    toLogin: false,
    loaded: true,

    assessments: new Array(),
    comparisonFilters: {},
    compareWithFilters: {},
    selectedAssessment: '0',
    results: new Array(),
    relations: new Array(),
    baseResults: { responses: new Array(), name: '' },
    selectedComparison: new Array(),
    selectedCompareWith: new Array(),
    selectedCompareWithResults: {},
    openedRows: new Array(),
    loading: false,
  };

  constructor(props) {
    super(props);

    this.onLogout = this.onLogout.bind(this);
    this.onToggleRow = this.onToggleRow.bind(this);
    this.renderTableRow = this.renderTableRow.bind(this);
  }

  public async componentDidMount() {
    const { services: { adminAPI, isUserLoggedIn } } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }

    const { data: { assessments } } = await adminAPI.getUserAssessments();
    this.setState({ assessments });
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }

  public onToggleRow(openedRows) {
    this.setState({ openedRows });
  }

  public onSelectAssessment = (event: React.SyntheticEvent) => {
    const target = event.target as HTMLInputElement;
    const { assessments } = this.state;
    const assessmentGroupID = target.value;
    const assessmentID = assessments
      .filter((assessment: any) => assessment.Group.id === Number(assessmentGroupID))[0].id;
    const { services: { adminAPI, currentUserID, currentUsername } } = this.props;

    this.setState({ selectedAssessment: assessmentGroupID, loading: true });

    adminAPI.getCurrentUserRelatedAssessmentResults({ assessmentGroupID })
      .then((results: any) => {
        const compareWithFilters = {};
        results.data.relations.forEach(user => { compareWithFilters[user.id] = user.name; });
        adminAPI.getAssessmentQuestionGroups({ assessmentID })
          .then((traits: any) => {
            const comparisonFilters = {};
            traits.data.groups.forEach(group => { comparisonFilters[group.id] = group.Title; });

            this.setState({
              comparisonFilters,
              compareWithFilters,
              results: results.data.results,
              relations: results.data.relations,
              baseResults: {
                name: currentUsername,
                responses: results.data.results.filter((res: any) => res.UserId === currentUserID),
              },
              loading: false,
            });
          })
          .catch(err => {
            alert('API error!');
          })
      })
      .catch(err => {
        alert('API error!');
      });
  }

  public onSelectComparison = (comparison: string) => (event: React.MouseEvent) => {
    let newSelectedComparison = Array();
    const { selectedComparison } = this.state;

    if (selectedComparison.includes(comparison)) {
      newSelectedComparison = selectedComparison.filter(c => c !== comparison);
    } else {
      newSelectedComparison = [...selectedComparison, comparison];
    }

    this.setState({ selectedComparison: newSelectedComparison });
  }

  public onSelectCompareWith = (comparison: string) => (event: React.MouseEvent)=> {
    let newSelectedCompareWith = Array();
    const { results, selectedCompareWith, selectedCompareWithResults } = this.state;

    if (selectedCompareWith.includes(comparison)) {
      console.log('Fired 1 ...')
      newSelectedCompareWith = selectedCompareWith.filter(c => c !== comparison);
    } else {
      newSelectedCompareWith = [...selectedCompareWith, comparison];

      if (!Object.keys(selectedCompareWithResults).includes(comparison)) {
        const assessmentResult = results.filter((res: any) => res.UserId === Number(comparison));
        this.setState({
          selectedCompareWithResults: {
            ...selectedCompareWithResults,
            [comparison]: assessmentResult},
        });
      }
    }

    this.setState({ selectedCompareWith: newSelectedCompareWith });
  }

  public riskLevelDescription = (score) => {
    if (score <= 24) {
      return 'Extremely High Alert';
    } else if (score <= 49) {
      return 'High Alert';
    } else if (score <= 74) {
      return 'Moderate Alert';
    } else if (score <= 99) {
      return 'Low Alert';
    }

    return 'No Alert';
  }

  public renderAssessmentPicker() {
    const { assessments, selectedAssessment } = this.state;

    if (assessments.length) {
      return (
        <div className="assessment-selector">
          <h3 className="title">First, pick an assessment</h3>
          <select
            name="assessment"
            data-arg="assessment"
            required={true}
            className="custom-select"
            value={selectedAssessment}
            onChange={this.onSelectAssessment}
          >
            <option value={0}>--</option>
            {assessments.map((assessment: any) => {
              return (
                <option key={assessment.Group.id} value={assessment.Group.id}>
                  {assessment.Group.Name}
                </option>
              );
            })}
          </select>
        </div>
      );
    }

    return null;
  }

  public renderComparisonFilterButtons() {
    const { comparisonFilters, selectedComparison } = this.state;

    if (Object.keys(comparisonFilters).length) {
      return (
        <div className="comparison-filters">
          <h3 className="title">Compare my responses on</h3>
          <div className="cf-buttons-wrapper cf-buttons-wrapper-4">
            {Object.entries(comparisonFilters).map((comparison: any) => {
              return (
                <button
                  key={comparison[0]}
                  className={
                    `cf-button ${selectedComparison.includes(comparison[0]) ? 'cf-button-active' : ''}`
                  }
                  onClick={this.onSelectComparison(comparison[0])}
                >
                  {comparison[1]}
                </button>
              );
            })}
          </div>
        </div>
      );
    }

    return null;
  }

  public renderCompareWithFilterButtons() {
    const { compareWithFilters, selectedCompareWith } = this.state;

    if (Object.keys(compareWithFilters).length) {
      return (
        <div className="comparison-filters">
          <h3 className="title">With responses for</h3>
          <div className="cf-buttons-wrapper cf-buttons-wrapper-2">
            {Object.entries(compareWithFilters).map((comparison: any) => {
              return (
                <button
                  key={comparison[0]}
                  className={
                    `cf-button ${selectedCompareWith.includes(comparison[0]) ? 'cf-button-active' : ''}`
                  }
                  onClick={this.onSelectCompareWith(comparison[0])}
                >
                  {comparison[1]}
                </button>
              );
            })}
          </div>
        </div>
      );
    }

    return null;
  }

  public renderRadarGraph() {
    const radarData = {};
    const radarKeys = new Array();
    const {
      baseResults,
      selectedCompareWith,
      selectedCompareWithResults,
      selectedComparison,
      comparisonFilters,
      compareWithFilters,
    } = this.state;

    const filteredSelectedCompareWithResults = Object.entries(selectedCompareWithResults)
      .filter((result) => selectedCompareWith.includes(result[0]));
    const filteredSelectedComparison = Object.keys(comparisonFilters)
      .filter((id) => selectedComparison.includes(id));

    if (baseResults.responses.length === 0) {
      return null;
    }

    baseResults.responses.forEach((res: any) => {
      if (filteredSelectedComparison.includes(String(res.GroupId))) {
        radarData[res.Group] = { ...radarData[res.Group], [baseResults.name]: res.GroupPercentageScore };
      }
    });

    radarKeys.push(baseResults.name);

    filteredSelectedCompareWithResults.forEach((data: any) => {
      const key = compareWithFilters[Number(data[0])];

      data[1].forEach((response) => {
        if (filteredSelectedComparison.includes(String(response.GroupId))) {
          radarData[response.Group] = {
            ...radarData[response.Group],
            [key]: response.GroupPercentageScore,
          };
        }
      });

      radarKeys.push(key);
    });

    const radarDataArray = Object.entries(radarData).map((entry) => {
      return { question: entry[0], ...entry[1] };
    });

    return (
      <div className="radar-container">
        <h2 className="cf-h2-heading">Radar Chart</h2>
        <RadarGraph
          maxValue={100}
          realData={radarDataArray}
          realKeys={radarKeys}
          useCustomLabel={false}
        />

        <button className="button blue-button cf-regular-button">
          Learn More
        </button>
      </div>
    );
  }

  public renderTableRow(props) {
    const { data } = props;
    const { services: { currentUserID: userID } } = this.props;
    const { baseResults, selectedCompareWithResults } = this.state;
    const comparisonData = [
      {
        id: userID,
        name: baseResults.name,
        score: data.score,
        maxScore: data.maxScore,
        percentage: data.percentage,
      }
    ];
    Object.entries(selectedCompareWithResults).forEach((result: any) => {
      result[1].forEach((res) => {
        if (data.id === res.GroupId) {
          comparisonData.push({
            id: res.UserId,
            name: res.User,
            score: res.GroupScore,
            maxScore: res.MaxGroupScore,
            percentage: `${res.GroupPercentageScore}%`,
          });
        }
      });
    });

    return (
      <div className="cf-expanded-row-content">
        <table className="cf-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Percentage</th>
            </tr>
          </thead>
          <tbody>
            {comparisonData.map((res, i) => {
              const score = res.score / res.maxScore;
              const isBelowAvg = score < 0.5;
              const key = `${i}-${res.id}`;

              return (
                <tr key={key}>
                  <td>{res.name}</td>
                  <td className={isBelowAvg ? 'cf-red' : 'cf-yellow'}>{res.percentage}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  public renderTable() {
    const { baseResults, openedRows, selectedComparison } = this.state;
    const tableData = baseResults.responses
      .filter(response => selectedComparison.includes(String(response.GroupId)))
      .map((res) => {
        return {
          id: res.GroupId,
          name: res.Group,
          percentage: `${res.GroupPercentageScore}%`,
          level: this.riskLevelDescription(res.GroupPercentageScore),
        }
      });

    const columns = [
      { label: 'ID', key: 'id', width: 10 },
      { label: 'Name', key: 'name', width: 40 },
      { label: 'Percentage', key: 'percentage', width: 20 },
      { label: 'Alert Level', key: 'level', width: 30 },
    ];

    if (tableData.length === 0) { return null; }

    return (
      <ExpandableTable
        onToggle={this.onToggleRow}
        maxOpen={3}
        openedRows={openedRows}
        maxBodyHeight={450}
        renderRow={this.renderTableRow}
        columns={columns}
        data={tableData}
        className="cf-expandable-table"
      />
    );
  }

  public render() {
    const { assessments, loading } = this.state;

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    if (assessments.length === 0) {
      return <Loader color="#acff24" />;
    }

    return (
      <div className="cf-page">
        <Navbar {...this.props} logoutParent={this.onLogout} />
        <div className="cf-container">
          <div className="cf-content">
            <h1 className="cf-page-heading">COMPARISONS</h1>
            <div className="cf-page-row cf-filters">
              {this.renderAssessmentPicker()}
              <button className="button blue-button cf-regular-button">
                Save Results
              </button>
            </div>
            {!loading
              ? (
                <React.Fragment>
                  <div className="cf-buttons-row">
                    {this.renderComparisonFilterButtons()}
                    {this.renderCompareWithFilterButtons()}
                  </div>
                  <div className="cf-page-row">{this.renderRadarGraph()}</div>
                  <div className="cf-page-row">
                    {this.renderTable()}
                  </div>
                </React.Fragment>
              ) : <Loader color="#acff24" />}
          </div>
        </div>
      </div>
    );
  }
}

export default withServices(ComparisonFilters);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Parent/ComparisonFilters/comparisonFilters.tsx